import React, { Fragment, useState, useRef, useEffect } from "react";
import { Table, Pagination, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

import { Link, useHistory } from "react-router-dom";
import Cookies from "universal-cookie";
import { getUsersTable, handleApprovalRequest } from "../../../apis/TableData";
import ApprovalConfirmationModal from "../modals/ApprovalConfirmationModal";

const UsersTable = () => {
  const cookies = new Cookies();
  const token = cookies.get("token");
  const history = useHistory();
  toast.configure();
  const [tableData, setTableData] = useState();
  const [dataCount, setDataCount] = useState(0);
  const [fname, setFName] = useState("");
  const [lname, setLName] = useState("");
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [modalAction, setModalAction] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const entriesPerPage = 10;

  useEffect(() => {
    if (token === null || token === undefined) {
      history.push("/page-login");
    }
    fetchTableData(0);
  }, []);

  const fetchTableData = (pageNo) => {
    getUsersTable(token, fname, lname, username, email, pageNo, entriesPerPage)
      .then((response) => {
        if (response.code == 200) {
          setTableData(response.data.data);
          setDataCount(response.data.count);
          setCurrentPage(pageNo);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const resetFilter = (e) => {
    e.preventDefault();
    getUsersTable(token, "", "", "", "", 0, entriesPerPage)
      .then((response) => {
        console.log(response);
        if (response.code == 200) {
          setTableData(response.data.data);
          setDataCount(response.data.count);
          setUsername("");
          setFName("");
          setLName("");
          setEmail("");
          setCurrentPage(0);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const queryFilter = (e) => {
    e.preventDefault();
    fetchTableData(0);
  };

  const totalPages = Math.ceil(dataCount / entriesPerPage);
  const pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);

  const handleApprovalClick = (user, action) => {
    setSelectedUser(user);
    setModalAction(action);
    setShowModal(true);
  };

  const handleModalConfirm = async () => {
    if (!selectedUser || !modalAction) return;

    setIsLoading(true);
    try {
      const response = await handleApprovalRequest(
        token,
        selectedUser.id,
        modalAction
      );
      
      if (response && response.code === 200) {
        toast.success(response.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
        });

        setTableData((prevData) =>
          prevData.map((user) =>
            user.id === selectedUser.id
              ? {
                  ...user,
                  approval_status:
                    modalAction === "approve" ? "approved" : "rejected",
                }
              : user
          )
        );

        handleModalClose();
      } else {
        toast.error(response.message || "Unexpected response from server", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
        });
      }
    } catch (error) {
      toast.error("An error occurred while processing the request", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleModalClose = () => {
    setShowModal(false);
    setSelectedUser(null);
    setModalAction("");
  };

  const handlePageChange = (pageNumber) => {
    fetchTableData(pageNumber - 1);
  };

  const handlePrevious = () => {
    if (currentPage > 0) {
      fetchTableData(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages - 1) {
      fetchTableData(currentPage + 1);
    }
  };

  return (
    <div className="col-12">
      <div className="row">
        <div className="form-group col-md-3">
          <label>First Name</label>
          <input
            type="text"
            className="form-control"
            value={fname}
            onChange={(e) => setFName(e.target.value)}
          />
        </div>
        <div className="form-group col-md-3">
          <label>Last Name</label>
          <input
            type="text"
            className="form-control"
            value={lname}
            onChange={(e) => setLName(e.target.value)}
          />
        </div>
        <div className="form-group col-md-3">
          <label>Username</label>
          <input
            type="text"
            className="form-control"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
        </div>
        <div className="form-group col-md-3">
          <label>Email</label>
          <input
            type="text"
            className="form-control"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
      </div>
      <div className="row mb-3 d-flex justify-content-center">
        <div className="form-group mr-2">
          <button
            type="submit"
            className="btn btn-primary"
            onClick={(e) => queryFilter(e)}
          >
            Submit
          </button>
        </div>
        <div className="form-group ml-2">
          <button
            type="reset"
            className="btn btn-primary"
            onClick={(e) => resetFilter(e)}
          >
            Reset
          </button>
        </div>
      </div>
      <div className="card">
        <div className="card-header">
          <h4 className="card-title">Profile Datatable</h4>
        </div>
        <div className="card-body">
          <Table responsive className="w-100">
            <div id="example_wrapper" className="dataTables_wrapper">
              <table id="example" className="display w-100 dataTable">
                <thead>
                  <tr role="row">
                    <th>Avatar</th>
                    <th>First Name</th>
                    <th>Last Name</th>
                    <th>Username</th>
                    <th>Email</th>
                    <th>Group</th>
                    <th>Active</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {tableData?.map((d, i) => (
                    <tr key={i}>
                      <td>
                        <img
                          className="rounded-circle"
                          width="35"
                          src={d?.avatar}
                          alt=""
                        />
                      </td>
                      <td>{d?.fname}</td>
                      <td>{d?.lname}</td>
                      <td>
                        <Link to={"/user-profile/" + d?.id}>{d?.username}</Link>
                      </td>
                      <td>{d?.email}</td>
                      <td>{d?.type}</td>
                      <td>{d?.active}</td>
                      <td>
                        <span
                          className={`badge badge-${
                            d?.approval_status === "approved"
                              ? "success"
                              : d?.approval_status === "rejected"
                              ? "danger"
                              : "warning"
                          }`}
                          style={{ 
                            minWidth: '70px',
                            padding: '6px 12px',
                            fontSize: '0.875rem',
                            textAlign: 'center',
                            display: 'inline-block'
                          }}
                        >
                          {d?.approval_status || "pending"}
                        </span>
                      </td>
                      <td>
                        <div className="d-flex flex-column gap-1">
                          {d?.approval_status === "pending" && (
                            <>
                              <Button
                                size="sm"
                                variant="success"
                                className="mb-1"
                                onClick={() => handleApprovalClick(d, "approve")}
                                style={{ minWidth: '70px' }}
                              >
                                Approve
                              </Button>
                              <Button
                                size="sm"
                                variant="danger"
                                onClick={() => handleApprovalClick(d, "reject")}
                                style={{ minWidth: '70px' }}
                              >
                                Reject
                              </Button>
                            </>
                          )}
                          {d?.approval_status === "approved" && (
                            <Button
                              size="sm"
                              variant="danger"
                              onClick={() => handleApprovalClick(d, "reject")}
                              style={{ minWidth: '70px' }}
                            >
                              Reject
                            </Button>
                          )}
                          {d?.approval_status === "rejected" && (
                            <Button
                              size="sm"
                              variant="success"
                              onClick={() => handleApprovalClick(d, "approve")}
                              style={{ minWidth: '70px' }}
                            >
                              Approve
                            </Button>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <div className="d-flex justify-content-between align-items-center mt-3">
                <div className="dataTables_info">
                  Showing {currentPage * entriesPerPage + 1} to{" "}
                  {Math.min((currentPage + 1) * entriesPerPage, dataCount)}
                  {" "}of {dataCount} entries
                </div>
                <div className="dataTables_paginate paging_simple_numbers">
                  <Pagination size="lg">
                    <li className="page-item page-indicator" onClick={handlePrevious}>
                      <Link className="paginate_button previous" to="#">
                        Previous
                      </Link>
                    </li>
                    {pageNumbers.map((number, i) => (
                      <Pagination.Item
                        key={i}
                        className={currentPage === i ? "active" : ""}
                        onClick={() => handlePageChange(number)}
                      >
                        {number}
                      </Pagination.Item>
                    ))}
                    <li className="page-item page-indicator" onClick={handleNext}>
                      <Link className="paginate_button next" to="#">
                        Next
                      </Link>
                    </li>
                  </Pagination>
                </div>
              </div>
            </div>
          </Table>
        </div>
      </div>

      <ApprovalConfirmationModal
        isOpen={showModal}
        onClose={handleModalClose}
        onConfirm={handleModalConfirm}
        action={modalAction}
        isLoading={isLoading}
      />
    </div>
  );
};

export default UsersTable;
